export function isObjectChanged<T>(a: T | undefined, b: T | undefined): boolean {
  return JSON.stringify(a) !== JSON.stringify(b);
}
